export const locale = {
  lang: 'en',
  data: {
    "online_booking": "Online Booking",
    "Inspection_Due": "Inspection Due",
    "Booked_on": "Booked on",
    "Booking_Date_Time": "Booking Date & Time",
    VIN_Number_official: 'VIN Number',
    SVC_Category_official: 'SVC Category',
    "plate_no_official": "Licence Plate",
    "View_vehicle_details": "View Vehicle Details",
    "transaction_receipt": "Transaction Receipt",
    "Slots_displayed_are_the_available_ones": "Slots displayed are the available ones",
    "Disclaimer": "Disclaimer",
    "Looks_like_we_dont_have_any_report_for_this_vehicle": "Look's like we don't have any report for this vehicle",
    for_online_booking_customers: "Stations for online booking customers",
    walkin_customers: "Stations for Walk-in Customers",    
    "vehicle_not_available": "Vehicle not available",
    "Vehicle_has_been_removed": "Vehicle has been removed.",
    "The_appointment_is_with_another_user": "The appointment is with another user.",
    TYPE_TO_SEARCH: 'Type to search...',
    "There_is_no_available_services": "There is no available services",
    "This_service_is_no_longer_available": "This service is no longer available.",
    "Welcome_to_WOQOD": "Welcome to WOQOD. Complete your profile to continue using the services. Fill in all required details to activate your account.",
    verify_email_txt_instructional: "You will receive an email with a verification code. Enter the code in the field below to complete the verification.",
    "Other Amount": "Other Amount",
    "Become_a_WOQOD_customer": "Become a WOQODe customer",
    Topup_amount_is: "Total Amount",
    Transaction_has_been_cancelled: "Transaction has been cancelled.",
    Transaction_has_been_failed: "Transaction has been Failed.",    
    Auto_Care: "Auto Care",
    Resend_Code: 'Resend Code',
    Enter_passport_number: "Enter passport number",
    Enter_cr_number: "Enter CR number",    
    Enter_QID_number: "Enter QID number",
    "DUE": {
      "INSPECTION": "Inspection Due in {{value}}",
      "YEARS": "Years",
      "MONTHS": "Months",
      "DAYS": "Days"
    },
    "dashboard": {
      "session_expired": "You are not authorized to access this session",
      Appointment_on: 'Appointment on',
      Booking_Confirmed_for: 'Booking Confirmed for',
      Loading: 'Loading',
      All_Vehicles: "All Vehicles",
      No_of_Vehicles: "No. of Vehicles",
      No_of_Tags: "No. of Tags",
      Consumption_Daily: "Consumption (Daily)",
      Transation_Limit: "Transaction Limit",
      Litres: "Litres",
      Active: "Active",
      Deactive: "Deactive",
      Your_vehicle_Etag_is_deactive: "Your vehicle E-tag is deactive.",
      View_History: "View History",
      Activate_Now: "Activate Now",
      View_all: "View all",
      Add_New_Vehicle: "Add New Vehicle",
      

      ETag: "E-Tag",
      Beneficiary_Limit: "Beneficiary Limit",
      Recent_Transactions: "Recent Transactions",
      Utilisation: "Utilisation",
      Value_QAR: "Value (QAR)",
      Edit_Limit: "Edit Limit >",
      Modify: "Modify",      
      Assign_Limit: "Assign Limit >",
      Topup_Summary: "Topup Summary",
      Assign_User_Limit: "Assign User Limit",
      Add_New: "Add New",
      Appoinments: "Appoinments",
      Loyalty_points: "Loyalty points >",
      Points_Redeemed: "Points Redeemed",
      Points_Earned: "Points Earned",
      Order_ID: 'Order ID',
      Activity_Type: 'Activity Type',
      Points_Change: 'Points Change',
      Activity_Date: 'Activity Date',
      Customer_Name: 'Customer Name',
      In_Progress: "In Progress",
      Recept: "Recept",
      "statistics": "Statistics",
      "topupAndUtilisation": "Topup and utilisation",
      "recentActivities": "Recent activities",
      "transactions": "Transactions",
      "beneficiary": "Beneficiary",
      "loyaltyPointsActivityLogs": "Loyalty Points Activity Logs",
      "promoAndDiscounts": "Promo & Discounts"
    },  
    See_all: "See all",
    "actions": "Actions",
    "profile_details": "Profile details",
    "first_name": "First Name",
    "last_name": "Last Name",
    "email": "Email Address",
    "mobile": "Mobile Number",
    "qid": "QID",
    "address": "Address",
    "dob": "Date of Birth",
    "gender": "Gender",
    "wallet": "Wallet",
    "current_balance": "Current Balance",
    "beneficiaries": "Beneficiaries",  
    "dashboard_wallet": {
      Vehicles_List: "My Vehicle(s) List",
      "Istamara_Expiry": "Istamara Expiry on {{date}}",
      "Licence_plate": "Licence Plate",
      "Vehicle_Name": "Vehicle Name",
      "Time": "Time",
      "Date": "Date",
      "Owner": "Owner",
      "Plate_type": "Plate Type",
      "Category": "Category",
  
      Get_Direction: "Get Direction",
      Download_Report: "Download Report",
      Done: "Done",
      Edit: "Edit",
      View_details: "View details",
      Service: "Service",
      Scheduled_Time: "Scheduled Time",
      Search_by_Plate_Number: "Search by Plate Number",
      "topUpSuccess": "Top-up has been done successfully",
      "amount": "QAR {{amount}}",
      "referenceId": "Reference ID: {{refId}}",
      "viewDetails": "View Details",
      "cardNumberLabel": "Card Number: {{card}}",
      "newBalance": "Your new balance is",
      "balanceAmount": "QR {{balance}}",
      "savedSuccessfully": "Saved Successfully",
      "paymentSummary": "Payment Summary",
      "paymentMethod": "Payment Methods",
      "paymentMethodValue": "Credit Card",
      "cardNumber": "Card Number",
      "cardNumberValue": "{{cardMasked}}",
      "serviceName": "Service Name",
      "serviceNameValue": "Topup",
      "location": "Location",
      "locationValue": "Online",
      "downloadReceipt": "Download Receipt",
      "viewReceipt": "View Receipt",      
    },  
    dashboardrevamp: {
      Get_the_offer: 'Get the offer',
      thisMonth: "This month",
      service: "Service",
      walletTransactions: "Wallet & Transactions",
      currentBalance: "Current Balance",
      transactions: "Transactions",
      topup: "Topup",
      searchByServiceName: "Search by Service Name",
      name: "Name",
      invoice: "Invoice",
      tracking: "Tracking",
      serviceName: "Service Name",
      dateTime: "Date & Time",
      status: "Status",
      amount: "Amount"  
    },
    "admin": {
      "Topup": "Topup",
      "LANGUAGE": "Language",
      "Dashboard": "Dashboard",
      "My_Profile": "My Profile",
      "My_Vehicle": "My Vehicle",
      "Appointment_History": "Appointment History",
      "Woqod_E_Tag": "Woqod E-Tag",
      "Settings": "Settings",
      "Notification": "Notification",
      "Helps": "Helps",
      SMS_Messages: 'SMS Messages',
      "my-profile": "My Profile",
      "my-vehicles": "My Vehicles",
      "appointment-history": "Appointment History",
      "my-wallet": "My Wallet",
      "woqod-e-tag": "Woqod E-Tag",
      "helps": "Helps"
    },
    popup: {
      Show_Receipt: "View Receipt",
      Show_Payment_Receipt: 'Show Payment Receipt',
      "Payment_Date": "Payment Date",
      "Licence_Plate": "Licence Plate",
      "Category": "Category",
      "VIN_Number": "VIN Number",
      "SVC_Category": "SVC Category",
      "Registered_on": "Registered On",
      "Download_Result": "Download Receipt",
      "Register": "Register"
    },
    "inspection_new": {
      Success: "Success",
      Canceled: "Canceled",
      Failed: "Failed",
      "change_booked_slot": "Modify Booking",
      "proceed_with_payment": "Pay Now",
      "vehicle_details": "Vehicle Details",
      "vehicle_plate": "Vehicle Plate",
      "vehicle_name": "Vehicle Name",
      "vehicle_type": "Vehicle Type",
      "payment_summary": "Payment Summary",
      "payment_status": "Payment Status",
      "total": "Total"
    },  
    "inspection_details": {
      "inspection": "Inspection",
      "inspected_on": "Inspected On",
      "plate": "Plate",
      "plate_type": "Plate Type",
      "qid": "QID",
      "technical_evaluation": "Technical Evaluation",
      "chassis": "Chassis",
      "mileage": "Mileage",
      "inspection_validity": "This inspection report is valid till:",
      "vehicle_inspection_report": "Vehicle Inspection Report",
      "passed": "Passed",
      "private": "Private",
      "terms_and_conditions": "Terms & Conditions",
      "terms_and_conditions_title": "Terms and Conditions for Inspections",      
      "legal_requirements": "Legal Requirements",
      "severity": "Severity",
      "minor": "Minor",
      "major": "Major",
      "visual_faults": "Visual / Technical Faults",
      failed: "Failed"
    },  
    TIMES: {
      AM: 'AM',
      PM: 'PM'
    },
    INSPECTION: {
      TITLE: 'Inspection',
      Service_name: "Service name",
      Plate_Type: "Plate Type",
      Fahes_Inspection_Booking: "FAHES Stations",
      Availability: "Availability",
      Check_your_availability_and_your_available_slots: "Check your availability and your available slots",
      Service_available_for_you: "Services available for you",
      Working_hours: "Working hours",
      Available_Slots: "Available Slots",
      Back: "Back",
      Next: "Next",
      Search_Locations: "Search Locations",
      Fully_Booked: "Fully Booked",
      Available: "Available",
      Selected: "Selected",
      Disable: "Disabled",
      Vehicles_for_Inspection: "Vehicles List",
      Enable_Next_Due_Inspection: "Enable Next Due Inspection",
      Number_Plate: "Plate Number",
      Inspection_Paid: "Booked and Paid",
      Book_Now: "Book Now",
      Pay_Now: "Pay Now",
      Remove_Vehicle: "Remove Vehicle",
      Remove_Vehicle_msg: "Are you sure you want to remove vehicle?",
      View_last_inspection_report: "View Last Inspection Report",
      Last_inspection: "Last inspection",
      Reg_Expiry: "Reg. Expiry",
      Model: "Model",
      Manufactor: "Manufactor",
      Type: "Type",
      I_agree_with_WOQOD_Terms_and_Conditions: "I agree with WOQOD Terms and Conditions",
      Booking_reference: "Booking reference",
      Booking_Details: "Booking Details",
      Car_plate: "Car plate",
      Date_and_Time: "Date & Time",
      Payment_Summary: "Payment Summary",
      Payment_Status: "Payment Status",
      Booking_Slot: "Booking Slot",
      Total: "Total",
      QAR: "QAR",
      Payment: "Payment",
      Select_any_payment_options_to_proceed_with_payment: "Select any payment options to proceed with payment",
      Add_new_card: "Add new card",
      Cancel: "Cancel",
    },
    MAP: {
      ALL: 'All',
      ALL_SERVICES: 'All services',
    },
    GDPR: {
      GDPR_TITLE: 'We value your privacy',
      GDPR_SUBTITLE: "We use cookies to improve your experience on our website. To accept all cookies, click 'Accept All,' alternatively you can set the preferred cookies by clicking on 'Cookie Preference.",
      GDPR_LEARNMORE: 'Learn more',
      CUSTOMIZE: 'Cookie Preference',
      REJECT: 'Reject',
      ACCEPT: 'Accept'
    },
    HEADER: {
    },
    WIDGET: {
      CHAT_BOT: 'Chatbot',
      NOTIFICATIONS: 'Notifications',
      SMS: 'SMS Messages',
    },
    SHARED: {
      Card_added_to_your_profile: 'Card added to your profile',
      Save_card_for_future_use_in_your_account: "Save card for future use in your account",
      "paymentMethod": "Payment Method",
      Types: "Types of",
      Oops_You_can_only_update_appointments_you_created: "Oops! You can only update appointments you created.",
      Please_log_in_to_book_an_appointment: "Please log in to book an appointment",
      Mobile_number_must_start_with_974_or_00974: "Mobile number must start with +974 or 00974",
      WOQOD_Latest_News_Events_and_Announcements: "WOQOD Latest News, Events and Announcements",
      This_gallery_is_currently_empty: "This gallery is currently empty.",
      No_events_available_at_the_moment: "No events available at the moment",
      GET_IN_TOUCH: "GET IN TOUCH",
      Have_a_question_or_Feedback: "Have a Question or Feedback?",
      questions: "If you have any questions , we’re here to help. If you have any suggestion or great ideas we’d love to hear those too!  Feel free to reach out we look forward hearing from you.",
      hear_them: "",
      READ_MORE: 'Read More',
      SEARCH: 'Search',
      DATE: 'Date',
      NEW: 'New',
      Interested: "I'm Interested",
      All_Jobs: 'View All Jobs',
      Feedback: 'Feedback',
      Locations: 'Locations',
      Faq: "FAQ's",
      view_Faq: "View All FAQ's",
      VIEW: "View",
      SUBMIT: "Submit",
      CONTACT_US:'Contact us',
      SUBCRIBED_SUCCESSFULLY: 'Subscribed Successfully ',
      APPLY_ALL: 'Apply All',
      FROM: 'From',
      TO: 'To',
      FILTER: 'Filter',
      KEYWORD: 'Keyword',
      HOME: 'Home',
      LAST_UPDATE: 'Published',
      VIEW_ALL: 'View All',
      CHOOSE_ONE: 'Choose One',
      RELATION: 'Relation',
      CHOOSE_Services: 'Choose Services',
      VIEW_MORE: 'View More',
      LEARN_MORE: 'Learn more',
      ADDRESS: 'Address',
      PHONE: 'Phone',
      FAX: 'Fax',
      EMAIL: 'E-mail',
      HOW_HELP: 'How we can help you?',
      WORKING: 'Working at WOQOD',
      WITH_GAS: 'With GAS',
      Proceed: 'Proceed To Payment',
      LOAD: 'Load More',
      LESS: 'Show Less',
      NO_DATA: 'There is No Data',
      NO_ACTIVE: 'No Active Tenders',
      VALID: 'Valid Until:',
      FAQ_CONTACT: 'Frequently Ask Questions',
      FEEDBACKS: 'Feedback',
      HELP_YOU: 'WE ARE HERE TO HELP YOU',
      OTHER_LOCATION: 'Other Locations',
      PROCEED: 'Proceed',
      RELATED_IMAGES: 'Related Images',
      RELATED_VEDIOS: 'Related Vedios',
      RELATED_FILES: 'Related files',
      Inspection_FAQ: 'Inspection FAQ’s',
      "FAHES_STATION": "Fahes Station",
      "ABOUT_FAHES": "About Fahes",
      "INSPECTION_TIPS": "Inspection Tips",
      "CUSTOMER_GUIDE": "Customer Guide",
      "CONTACT_FAHES": "Contact Fahes"
    },
    HERO_HOME_PAGE_BOTTOM: {
      FUEL_PRICES: 'Fuel Prices',
      Cash_Fuel_Prices: 'Cash Fuel Prices',      
      Everything_QJET_does_internally_or_externally: "Everything QJET does internally or externally.",
      EVERYTHING_WOQOD_DOES_INTERNALLY_OR_EXTERNALLY: 'Everything WOQOD does internally or externally.',
    },
    TENDER: {
      SUBSCRIBR_TO_ALERTS: 'Subscribe To Alerts',
    },
    CURRENCIES: {
      QAR_al: 'QR',
      QAR: 'QR',      
      QR: 'QR'
    },
    E_SERVICES_SECTION: {
      WOQOD_E_SERVICES: 'WOQOD e-Services',
      FAHES_E_SERVICES: 'FAHES e-Services',
      PRODUCT_SERVICES: 'Products and Services',
      HEART_OF_WOQOOD: "The heart of WOQOD's business is our fuels.",
      TENDERS: "Tenders",
      WHISTLE: 'Whistle Blowing',
      SERVICES: 'Services',
      ONLINE_INSPECTION_REPORT: 'Online Inspection Report'
    },
    PROMOTIONS: {
      PROMOTIONS: 'Promotions',
      VIEW_ALL_PROMOTIONS: 'View all Promotions',
      VIEW_ALL: 'View all ',
      RELATED_PROMOTIONS: 'Related Promotions',
      OFFERS_AND_PROMOTIONS: 'OFFERS AND PROMOTIONS',
      PROMOTIONS_EXPIRED_ON: 'Promotions Expires on',
      LATEST_PEOMOTIONS: 'Latest Promotions',
    },
    NEWS: {
      WOQOD_NEWS: 'WOQOD News',
      VIEW_ALL_NEWS: 'View all News',
      PRESS_RELEASE_NEWS: 'Press Release & News'
    },
    SOCIAL_WIDGET: {
      CHECK_ALL: 'Check all',
      SOCIAL_ACCOUNTS: 'Social Accounts'
    },
    WALLET: {
      transaction_date_and_time: 'Transaction Date & Time',
      Fuel_Transactions: "Fuel Transactions",
      Payouts: "Payouts",
      Topup_History: "Topup History",
      Other_Services: "Other Services",
      Date: "Date",
      Amount: "Amount",
      Address: "Address",
      Plate_number: 'Plate number',
      Time: "Time",
      Payment_Type: "Payment Type",
      Service_Type: "Service Type"
    },
    FEEDBACK: {
      Vehicles: "Vehicles",
      FEILD_CANT: "Field can't be empty",
      FULL_NAME: 'Full Name',
      COMPANY: 'Company',
      TITLE: 'Title',
      EMAIL: 'Email',
      COMMENT: 'Comment',
      MOBILE_NUMBER: 'Mobile Number',
      PLATE_NUMBER: 'Plate number',
      CATEGORY: 'Category',
      SOURCE: 'Source',
      SECTOR: 'Sector',
      SELECT_SECTOR: 'Select Sector',
      SELECT_CATEGORY: 'Select Your Category',
      SELECT_SOURCE: 'Select Your Source',
      SELECT_DEPATMENT: 'Select Department',
      SELECT_TYPE: 'Select Your Feedback',
      SELECT_PLATE_TYPE: 'Plate Type',
      DEPARTMENT: 'Department',
      type: 'Feedback Type',
      ATTACHMENT: 'Attach File',
      SERVIECS: 'Services ',
      NAME: 'Name',
      DESCRIPTION: 'Description',
      FORM_TITLE: 'Feedback Form',
      CONNECT: 'Connect us for new business opportunities and collaborations',
      CONTACT_US: 'Contact us',
      CONTACT_SELECT: 'Select any one from the below to proceed',
      ATTACHMENT_UPLOAD: 'Upload your file',
      HINT: 'upload files with extensions xls, xlsx, doc, docx, PDF, JPEG, PNG, and JIF. The maximum allowed file size is 5 MB, the user can add up to 5 attachments.',
      WRITE_HERE: 'Write here…'
    },
    PETROL_STATION: {
      WOQOD_Charge: "WOQOD Charge",
      CNG: "CNG",
      All_Stations: "All Stations",
      ALL: "All",
      sidra_stand_alone: "Sidra Stand Alone",
      sidra_petrol_station: "Sidra Petrol Station",
      PETROL_STATION: 'Petrol Station',
      FIND_THE_NEAREST_PETROL_STATION_AND_KNOW_THE_SERVICES_IT_OFFERS: 'Find the nearest petrol station and know the services it offers',
      SELECT_YOUR_PETROL_STATION_TYPE: 'Select Your Petrol Station Type',
      SELECT_YOUR_PETROL_STATION_STATUS: 'Select Your Petrol Station Status',
      SELECT_FROM_LIST_OF_THE_SERVICES: 'Select From List Of The Services',
      FIND_YOUR_PETROL_STATION: 'Find Your Petrol Station',
      FIND_YOUR_STATION: 'Find Your Station',
      FIND_YOUR_SIDRA_STATION: 'Find Your Sidra Station',
      FIND_YOUR_WOQOD_CHARGE_STATION: "Find Your Woqod Charge Station",
      FIND_YOUR_CNG_STATION: "Find Your CNG Station",
      FIND_YOUR_FAHES_STATION: 'Find Your Fahes Station',
      CLEAR_SELECTED_FILTERS: 'clear selected filters',
      EXPLORE_MORE_SERVICES: 'Explore more services',
      CLEAR_FILTERS: 'Clear Filters',
      RESET_ALL: 'Reset All',
      MARINE_STATION: 'Marine Station',
      MOBILE_STATION: 'Mobile Station',
      ACTIVE: 'Active',
      NEAR: 'Petrol Station Near Me',
      UPCOMING: 'Upcoming',
      SEND: 'Send',
      FUEL: 'Fuel',
      SIDRA: 'Sidra',
      FAHES: 'Fahes',
      ALL_TYPES: 'All Types',
      STAND_ALONE: 'Stand Alone'
    },
    FOOTER: {
      COPY_RIGHT_WITHOUT_YEAR: 'Copyright © {{pageType}} All rights reserved',
      COPY_RIGHT_WITH_YEAR: 'Copyright © {{cYear}}, {{pageType}} All rights reserved'
    },
    SHARE_BREADCRUMB: {
      SHARE_THIS: 'Share this',
      SHARE: 'Share :',
    },
    DASHBOARD: {
      BACK_TO_WEBSITE: 'Back to website',
      Enter: "Enter number",
      Add_Beneficiary: 'Add Beneficiary',
      Select_a_Beneficiaries: "Add Beneficiary",
      back: "< Back",
      "First_Name": "First Name",
      Last_Name: "Last Name",
      Email_short: "Email",
      QID_Passport_Number: "QID / Passport Number",
      Enter_your_relative_type: "Enter your relative type",
      Enter_Wallet_Limit: "Enter Wallet Limit",
      Enter_your_first_name: "Enter your first name",
      Enter_your_last_name: "Enter your last name",
      Enter_your_email: "Enter your email",
      Enter_a_valid_ID: "Enter a valid ID",
      Enter_here: "Enter here",
      "eg_QR_12000": "eg: QR 12000",
      Beneficiaries_added_successfully: "Beneficiaries added successfully!",
      New_Beneficiary_account_name_added_under_your_account_part1: "New Beneficiary",
      New_Beneficiary_account_name_added_under_your_account_part2: "added under your account",
      Used: "Used",
      out_of: "out of",
      Current_assigned_limit: "Current assigned limit",
      Limit_updated_successfully: "Limit updated successfully!",
      Update_Limit: "Update Limit",
      Instant: "Instant",
      Set_limit_between_QR_200_to_QR_400: "Set limit between QR {{count1}} to QR {{count2}}",
      Set_limit: "Set limit",
      Assing_limit: "Assing limit",
      Assing_limit2: "Assing limit",      
      Daily: "Daily",
      Weekly: "Weekly",
      Monthly: "Monthly",
      Approval_pending: "Approval pending",
      The_added_beneficiary_approval_is_still_pending: "The added beneficiary approval is still pending, please wait until",
      The_existing_beneficiaries_are_2_out_of_3: "The existing beneficiaries are {{count1}} out of {{count2}}",
      You_can_add_other_beneficiary_later: "You can add other beneficiary later",
      Beneficiary_account_removed: "Beneficiary account removed",
      Are_you_sure_you_want_to_deactivate_your_account_permanently: "Are you sure you want to deactivate your account permanently?",
      Are_you_sure_you_want_to_remove_this_beneficiary: "Are you sure you want to remove this beneficiary?",
      Increase_for_additional_limit: "Increase for additional limit >",
      used_out_of: "used out of",
      Wallet_Limit: "Wallet Limit",
      Beneficiary_Account: "Beneficiary Account",
      Remove_Beneficiary: "Remove Beneficiary",
      Delete_Account: "Delete Account",
      HELP_YOU: 'We are always here to help you',
      FIND: 'Find here other options',
      TRANSACTIONS: 'Transactions',
      TOPUP: 'Topup',
      THIS_MOUNTH: 'This month',
      SELECT_CAR: 'Select car',
      NEW_VEHICLE: 'Add New Vehicle',
      UPCOMING: 'Upcoming',
      COMPLETED: 'Completed',
      CANCELLED: 'Cancelled',
      ADD_NEW_APPOINTMENT: 'Add New Appointment',
      STEPS_APPOINTMENT: 'Steps Appointment',
      DASHBOARD: 'Dashboard',
      PROFILE: 'Profile',
      DEACTIVATE: 'Deactivate Account',
      Company_details: "Company details",
      Beneficiaries: "Beneficiaries",
      MY_PROFILE: 'My Profile',
      MY_VEHICLE: 'My Vehicle',
      APPOINTMENT_HISTORY: 'Appointment History',
      WALLET: 'Wallet',
      Frequently: 'Frequently asked questions',
      CHAT: 'Chat box',
      CALL: 'Call centre (Offline Support)',
      HELP: 'Need Help?',
      WHATS_APP: 'WhatsApp',
      FACEBOOK: 'Facebook Messenger',
      INSTGRAM: 'Instagram',
      SETTINGS: 'Settings',
      HELP_ASIDE: 'Helps',
      LANG: 'LANGUAGE',
      ADMIN: 'Admin User',
      MODAL_SUB_TITLE: 'All your account related details will be removed.',
      Email: 'Email Address',
      PHONE: 'Mobile',
      OTP_TITLE: 'Get OTP',
      OTP_DESC: 'OTP will send your registered mobile Number',
      NUMBER: 'Cost of Tag + Installation Charge',
      NUMBER_OF_TAG: 'Number of Tags',
      TOTAL: 'Total Price',
      BACK: 'Back',
      SAVE: 'Save & Continue Later',
      SAVE_S: 'Save',
      NEXT: 'Next',
      EDIT: 'Edit',
      RECOMMENDED: 'Recommended size is 256×256px, must be in .jpg or .png',
      ACCOUNT: 'Account Type',
      AGREE: 'I agree with Fahes’s Terms and Conditions',
      AGREE_WOQOD: 'I agree with WOQOD Terms and Conditions',
      BOOKING: 'Booking Confirmation Notification',
      BOOKING_NOTIFICATION: 'Booking Changed Notification',
      ORDER: 'Order Delivered Notification',
      EMAIL: 'Email Notification',
      CURRENT: 'Current Balance',
      NOMINAL: 'Enter amount (QR {{min}}–{{max}})',
      INSTANT: 'Instant',
      PAYMENT: 'Continue To Payment',
      VIEW_PROFILE: 'View Profile',
      MY_WALLET: 'My Wallet',
      LOG_OUT: 'Logout',
      EDIT_PROFILE: 'Edit Profile',
      Actions: 'Actions',
      Deactive: 'Deactive',
      CANCEL: 'Cancel',
      SAVE_CHANGES: 'Save Changes',
      RESONE_FOR_DEACTIVATE: 'Resone for deactivate',
      RESONE_FOR_DELETE: 'Resone for delete',
      FAILED: 'Failed',
      NA: 'N/A',
      SUCCESS: 'Success',
    },
    PROMOTION_FILTER: {
      FILTER_PROMOTIONS: 'Filter Promotions',
      LOCATION: 'Location',
      DATE_RANGE: 'Date Range',
      PROMOTION_CATEGORY: 'Promotion Category',
      PROMOTION_STATUS: 'Promotion Status',
      APPLY_FILTER: 'Click Here'
    },
    ABOUT_US: {
      OUR_MISSION: 'OUR MISSION',
      OUR_STORY: 'Our Story',
      READ_FULL_STORY: 'Read Full Story',
      OUR_LEADERSHIP: 'Our Leadership',
      OUR_HERITAGE: 'Our Heritage',
      OUR_VISION: 'OUR VISION',
      OUR_VALUES: 'OUR VALUES',
      PROFESSIONAL: 'Professional',
      RLEATED: 'Related Items',
      RLEATED_CONTENT: 'Related Content',
    },
    FAHES_MEDIA_CENTER: {
      NEWS: 'News & Announcements',
      MULTIMEDIA: 'Multimedia',
      EVENTS: 'Events',
      VIEW: 'View All',
      OUR_LASTEST_NEWS: 'Our Latest News & Announcements',
      OUR_LASTEST_MULTIMEDIA: 'Our Latest Multimedia',
      OUR_LASTEST_EVENTS: 'Our Latest Events',
      READ_MORE: 'Read More',
      READ_LESS: 'Read Less',
      SEARCH: 'Search by keyword',
      FILTER: 'Filter',
      LOAD_MORE: 'Load More',
      MILESTONES: 'MILESTONES',
      MILESTONE_OUR: 'Our evolution since 2003 until now',
      OF: 'of',

    },
    PERIOD: {
      PM: 'PM',
      AM: 'AM',
    },
    MONTHS: {
      JAN: 'Jan',
      FEB: 'Feb',
      MAR: 'Mar',
      APR: 'Apr',
      MAY: 'May',
      JUN: 'Jun',
      JUL: 'Jul',
      AUG: 'Aug',
      SEP: 'Sep',
      OCT: 'Oct',
      NOV: 'Nov',
      DEC: 'Dec',

      JANUARY: "January",
      FEBRUARY: "February",
      MARCH: "March",
      APRIL: "April",
      JUNE: "June",
      JULY: "July",
      AUGUST: "August",
      SEPTEMBER: "September",
      OCTOBER: "October",
      NOVEMBER: "November",
      DECEMBER: "December"
    },
    TRAFFIC_SERVISE: {
      TITLE_STORY: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
      BUTTON_STORY: 'MOI',
      STATION: 'Station Map',
      INSURANCE: 'Insurance',
      LOCATION: 'Location',
      STATUS: 'Station status',
      STATION_CONTACT: 'Station Contacts Person Details',
      TYPE: 'Station Type',
      AVAILABLE: 'Available Services',
    },
    SERVICE_INSPESTION: {
      "Transaction_done_by_card": "Transaction done by card",
      "PAYMENT_COMPLETED": "The payment has been done for the vehicle",
      "TRANSACTION_IN_PROGRESS": "The transaction is in progress",
      save_and_book_now: "Save And Book Now",
      save_and_pay: "Save And Pay",
      save_only: 'Save Only',
      save_vehicle: "Save Vehicle",
      add_a_vehicle: "Add a vehicle",
      Congratulations_Your_booking_has_been_reserved_for_the: "Congratulations! Your booking has been reserved for the {{serviceName}}",
      Back_to_Vehicle_Listing: "Back to Vehicle Listing",
      Initiate_Booking: "Initiate Booking",
      Congratulations_Your_payment_has_been_successfully_made: "Congratulations! Your payment has been successfully made",
      Payment_DateTime: "Payment Date & Time",
      View_Booking_Details: "View Booking Details",
      Pending: "Pending",
      Paid: "Paid",
      Payment_Status: "Payment Status",
      Booking_Slot: "Booking Slot",
      "Booking_confirm_for": "Booking confirmed for",
      Already_Booked: "Booked Only",
      PAID_ONLY: 'Paid Only',
      Cancel_Booking: "Cancel Booking",
      Back_To_Home: "Back To Home",
      Modify_Booking: "Modify Booking",
      Inspections: "Inspections",
      Select_any_payment_options_to_proceed_with_payment: "Select any payment options to proceed with payment",
      Wallet_Payment: "Wallet Payment",
      Select_a_wallet_to_complete_your_payment_securely: "Select a wallet to complete your payment securely.",
      WOQOD_Wallet: "WOQOD Wallet",
      Available_Balance: "Available Balance",
      "Payment_reference": "Payment reference",
      Payment_Confirmed_for_a_vehicle_plate_number: "Payment Confirmed for vehicle plate number",
      Booking_Confirmed_for_a_vehicle_plate_number: "Booking Confirmed for vehicle plate number",      
      Payment_Confirmed_for_a_vehicle_plate_number_withstatus: "Payment {{status}} for a vehicle plate number",
      payment_success_txt: 'Payment Confirmed for a vehicle plate number',
      payment_canceled_txt: 'Payment Canceled for a vehicle plate number',
      payment_pending_txt: 'Payment Pending for a vehicle plate number',
      payment_failed_txt: 'Payment Failed for a vehicle plate number',      
      Congratulations_Your_slot_has_been_reserved_for_the_inspection: "Congratulations! Your slot has been reserved for the inspection.",
      Vehicle_category: "Vehicle category",
      Disclaimer_part1: "**Disclaimer : You are requested to arrive at the station",
      Disclaimer_part2: "15 minutes",
      Disclaimer_part3: "prior to your reserved time slot.",
      Confirm_Pay_Later: "Confirm & Pay Later",
      Confirm_And_Proceed_To_Pay: "Confirm And Proceed To Pay",
      I_agree: "I agree",
      Terms_Conditions: "Terms & Conditions",
      Terms_and_conditions_for_Inspections: "Terms and conditions for Inspections",
      Open_24_hours: "Open 24 hours",
      Station_Details: "Station Details",
      Vehicle_Name: "Vehicle Name",
      Plate_Type: "Plate Type",
      Disclaimer_Review_and_confirm_booking_before_time_runs_out: "**Disclaimer Review and confirm booking before time runs out.",
      Total: "Total",
      QAR: "QAR",
      Appointment: "Appointment",
      Date: "Date",
      Time_Slot: "Time Slot",
      Open: "Open",
      Summary_of_your_booking_for_a_vehicle_plate_number: "Summary of your booking for a vehicle plate number",
      Please_review_the_below_details_and_confirm_your_slot_for_the_reservation: "Please review the below details and confirm your slot for the reservation",
      Please_review_the_below_details_and_confirm_your_slot_for_the_reservation_dynamic: "Please review the below details and confirm your {{serviceName}} slot for the reservation",      
      "Useful_Tips": "Useful Tips",
      "You_dont_have_any_vehicles_registered_on_your_account": "You don’t have any vehicles registered on your account. Please add a vehicle to proceed with the inspection booking",
      "aVehicleType": "Vehicle Type",
      "ownerQId": "Owner QID",
      "dateFirstRegistered": "Date First Registered",
      "vehicleWeight": "Vehicle Weight (kg)",
      "vehicleWeightwithLoad": "Vehicle Weight with Load (kg)",
      "inspectionType": "Inspection Type",
      "expiresOn": "Expires On",  
      Shape_of_Vehicle: "Shape of Vehicle",
      Beneficiary: "Beneficiary",
      Registration_Type: "Registration Type",
      YOUR_BOOKING: 'Your booking Confirmed Successfully',
      CONGRATS: 'Congratulations your tickets are successfully booked',
      ID: 'Booking Confirmation ID:',
      VIEW_SUMMARY: 'View Summary',
      BOOKING_SUMMARY: 'Booking Summary',
      ASSIGN: 'assign A Job',
      FEE: 'Inspection Fee',
      APPOINTMENT: 'Appointment Reference Number ',
      NAME: 'Assigned Name',
      REMOVE: 'Remove Car',
      SELECT: 'Select',
      CANCEL: 'Cancel',
      CONFIRM: 'Confirm',
      NO_OF: 'No of vehicle:',
      APPLY: 'Apply for all',
      BACK: 'Cancel',
      DUE: 'Due Inspection',
      CLEAR: 'Clear All',
      SORT: 'Sort By:',
      ONLY: 'Only one re-inspection is free',
      APPROX: 'Approx Total Price',
      LIST: 'Next Due Inspection vehicles list',
      DESCRIPTION: 'Individual vehicles that are less than 3 years old, they don’t require inspection',
      BOOKING_CONFIREMD: 'Booking Confirmed',
      REFERENCE: 'Booking reference',
      VEHICLE_NAME: 'Vehicle name',
      PLATE: 'Plate',
      AMOUNT: 'Amount',
      DATE: 'Appointment Date & Time',
      CHOOSE: 'Choose your Vehicle',
      DATE_TIME: 'Select Date & Time',
      INSPECTED_DATE: 'Inspected date',
      INSPECTED_STATUS: 'Inspection status',
      DATE_AND_TIME: 'Date & Time',
      PAYMENT: 'Payment Summary',
      NO_OF_CAR: 'No. Of Cars',
      PRICE_SELECTED: 'Price of Selected Vehicle',
      SUB_TOTAL: 'Sub Total',
      CANCEL_BOOKING: 'Are you sure you want to cancel?',
      remove_CARD: 'Remove Card',
      CANCEL_CARD: 'Are you sure you want to remove a card?',
      YES: 'Yes',
      NO: 'No',
      ISTEMARA_MESSAGENotDue: 'This vehicle is not due for inspection for 3 years from registration. Would you like to Proceed anyway?',
      ISTEMARA_MESSAGEDue: "The istemara (vehicle registration) for this vehicle is still valid for more than {{days}} days! Do you still want to proceed with the inspection booking?",
      New_Vechile: 'Add New Vechile',
      SAVE_PROCEED: 'Save And Proceed Booking',
      PLATE_DETAILS: 'Vehicle Plate Details',
      VEHICLE_INFORMATION: 'Vehicle Information',
      OWNER_NAME: 'Owner Name',
      OWNER_ID: 'Owner Id',
      OTHER_COLOR: 'Owner Color Des.',
      OWNER_NATIONALTIY: 'Owner Nationality',
      COUNTRY: 'Country',
      CHASIS: 'Chassis Number ',
      CONTACT_TRAFFIC: 'Contact Traffic ',
      ENGINE_NUMBER: 'Engine Number',
      FIRST_REGISTRATION: 'Date First Registered',
      LOAD_WEIGHT: 'Load Weight',
      MAIN_COLOR_DESC: 'Main Color Des.',
      MAIN_SHADE_DESC: 'Main Shade Desc',
      MANUFACTURE_DESCRIPTION: 'Manufacture Des.',
      MODEL_DESCRIPTION: 'Model Des.',
      MODEL_YEAR: 'Model Year',
      NUMBER_OF_CYLINDERS: 'Number of Cylinders',
      NUMBER_OF_SEATS: 'Number of Seats',
      PLATE_NUMBER: 'Plate Number',
      PLATE_TYPE: 'Plate Type',
      PLATE_TYPE_DESCRIPTION: 'Plate Type Description',
      REGISTRATION_END_DATE: 'Reg. Expiry',
      REGISTRATION_REN_DATE: 'Registration Ren Date',
      TEST_REQUIRED: 'Test Required',
      VIHICLE_STYLE_DESCRIPTION: 'Vehicle Style Description',
      A_VEHICLE_TYPE: 'A Vehicle Type',
      VIHICLHE_WEIGHT: 'Vehicle Weight',
      VIHCHLE_WEIGHT_WITH_LOAD: 'Vehicle Weight with Load',

    },
    MEDIA_TYPES: {
      ALL: 'All',
      VIDEOS: 'Videos',
      GALLERIES: 'Galleries',
      IMAGES: 'Images',
      INFOGRAPHICS: 'Infographics'
    },
    MEDIA_CENTER: {
      NEWS_AND_ANNOUNCMENTS: 'News & Announcements',
      MULTIMEDIA: 'Multimedia',
      EVENTS: 'Events',
      PUBLISHED: 'Published:',
      START_DATE: 'Start Date:',
      END_DATE: 'End Date:',
      RELATED_NEWS: 'Related News',
      RELATED_EVENTS: 'Related Events',
    },
    EVENT: {
      EVENT_CATEGORY: 'ALL Category',
      FILTER_THE_EVENT_BY: 'Filter the events by',
      EVENT_INFORMATION: 'Event information',
    },
    MULTIMEDIA: {
      SEARCH_BY_NAME_DESCRIPTION: 'Search by name/description',
      SEARCH_BY_NAME: 'Search by name'
    },
    BREADCRUMB: {
      CORPORATE_SOCIAL_RESPONSIBILITY: 'Corporate Social Responsibility',
      BECOME_A_SUPPLIER: 'Become a Supplier',
      TENDER_REQUEST: 'Tender Request',
      TENDER_ALERT: 'Tender Alert',
      TENDERS_AND_SUPPLIER: 'Tenders and Supplier',
      PAGES: 'Pages',
      SUCCESS: 'Success',
      MEDIA_CENTER: 'Media Center',
      NEWS_AND_ANNOUNCEMENTS: 'News and Announcements',
      NEWS: 'News',
      EVENTS: 'Events',
      MULTIMEDIA: 'Multimedia',
      VIDEOS: 'Videos',
      GALLERIES: 'Galleries',
      IMAGES: 'Images',
      photos: 'Photos',
      ENVIRONMENTAL_MANAGEMENT: 'Environmental Management',
      PETROL_STATION_SAFETY_INSTRUCTIONS: 'Petrol Stations Safety Instructions',
      INTEGRATED_MANAGEMENT_SYSTEM: 'Integrated Management System',
      AWARENESS_CAMPAIGN: 'Awareness Campaign',
      BRAND_GUIDELINES: 'Brand Guidelines',
      COMPANY_PROFILE: 'Company Profile',
      HEALTH_AND_SAFETY: 'Health and Safety',
      PROMOTIONS: 'Promotions',
      FAHES: 'Fahes',
      QJET: 'QJET',
      CODE_OF_ETHICS: 'Code Of Ethics-and-Conducts',
      WHY_WOQOD: 'Why Woqod',
      CAREERS: 'Careers',
      WHAT_WE_DO: 'What We Do',
      EQUALITY_DIVERSITY_INCLUSION: 'Equality, diversity & inclusion',
      WHAT_WE_LOOK_FOR: 'What We Look For',
      INTERVIEW_TIPS: 'Interview Tips',
      GET_NOTICED: 'Get Noticed',
      TALENT_DEVELOPMENT_STRATEGY: 'Talent Development Strategy',
      QATARAIZATION: 'Qatarization',
      LIFE_AT_WOQOD: 'Life at Woqod',
      WOQOD_CULTURE: 'Woqod Culture',
      BENEFITS: 'Benefits',
      TOP_TEN_REASON_TO_CHOOSE_WOQOD: 'Top 10 Reason To Choose Woqod',
      MEET_OUR_TEAM: 'Meet Our Team',
      FIVE_WAYS_TO_HELP_YOU_FIND_THE_RIGHT_CAREER_PATH: 'Five Ways To Help You Find The Right Career Path',
      SEARCH_RESULT: 'Search Results',
      FAHES_ABOUT_US: 'about us',
      FAHES_WHAT_WE_DO: 'What We DO',
      FAHES_WHO_WE_ARE: 'Who we are',
      FAHES_CONTACT_US: 'contact us',
      SYSTEMS_AND_REGULATION: 'systems and regulations',
      WOQODE_TAG: 'Woqode Tag',
      RETAIL: 'Retail',
      AUTO_CARE_SERVICE: 'Auto Care Service',
      BUSINESS_WITH_WOQOD: 'Business with woqod',
      FAQ: 'FAQ',
      SUSTAINABILITY: 'Sustainability',
      VISION_MISSION_VALUES: 'Vision Mission Values',
      ABOUT_US: 'About us',
      KENAR_SHOP: 'Kenar Shop',
      SIDRA: 'Sidra',
      TENDER_DETAILS: 'Tender Details',
      TENDER_AND_SUPPLIER: 'Procurement & Contracts',
      SHAFAF: 'Shafaf',
      SERVICES: 'Services',
      ERM: 'ERM',
      LUBRICANTS: 'Lubricants',
      CAREER_JOBS: 'Career Jobs',
      LEADERSHIP: 'Our LeaderShip',
      BUSINESS_CONTINUITY_MANAGEMENT: 'Business Continuity Management',
      ENTERPRISE_RISK_MANAGEMENT: 'Enterprise Risk Management',
      Document: 'Documents',
      REQUEST_E_TAG: 'Request E Tag',
      WALLET: 'WOQOD Wallet',
      Vacancies: 'Vacancies ',
      TENDER: 'Tenders'
    },
    CAREER_FILTER: {
      KEYWORD_SEARCH: 'Keyword Search',
      SELECT_LOCATION: 'Select Location',
      SELECT_DEPARTMENTS: 'Select Departments',
      FILTER_BY_TAGS: 'FILTER BY TAGS',
      MORE_TAGS: 'MORE TAGS',
      FILTER_BY_SALARY_RANGE: 'FILTER BY Salary RANGE',
      FULL_TIME_ONLY: 'Full time only',
      INSIDE_DOHA_QATAR: 'Inside Doha, Qatar',
      FILTER: 'Filter',
      SUBSIDIARY: 'Subsidiary',
    },
    RANGE: {
      MIN_SALARY: 'Min salary',
      MAX_SALARY: 'Max salary'
    },
    CAREER_LISTING: {
      current_location: "Current Location",
      Job_Details: "Job Details",
      Apply: "Apply",
      WOQOD_Vacancies: "WOQOD Vacancies",
      JOB_ID: 'Job ID',
      INDUSTRY: 'Industry',
      JOB_INFORMATION: 'Job Information',
      JOB_TIME: 'Job Time',
      JOB_LOCATION: 'Current Location',
      CITY: 'City',
      STATE: 'State/Province',
      COUNTRY: 'Country',
      SALARY: 'Salary',
      ZIP: 'Zip/Postal Code',
      REQUIREMENTS: 'Requirements',
      JOB_REQUIREMENTS:'Job Requirements',
      COMPANY:'Company',
      DETAILS: 'Details',
      INTERSTED: "I'm Interested",
      REQUEST: 'Request A Document',
      CAREER_JOB: 'Job Title',
      SECOND_NAME: 'Second Name',
      NATIONALITY: 'Nationality',
      CV_FILE: 'CV File',
      EDUCATION_DEGREE: 'Educational Qualification',
      FIELD: 'Field Of Study',
      CURRENT: 'Current Employment Status',
      YEARS: 'Years of Experience',
      WORK: 'Current/Previous Work industry',
      EMPLOYER: 'Current/Previous Employer',
      UNVIERSITY: 'Educational Certificate',
      DESC: 'Description',
      JOB_CODE: 'Job Code',
      APPLYING: 'You Are Applying For ',
      DESCRIPTION: 'Description',
      DATE_APP: 'Job Application Deadline Date',
    },
    TENDER_DETAILS: {
      Transation_date: 'Transaction date',
      TENDER_INFORMATION: 'Tender Information',
      S_NUMBER: 'Tender Serial Number',
      TENDER_NUMBER: 'Tender Number',
      TEBDER_CATEGORY: 'Tender Category',
      FEE: 'Tender Fee',
      SCOPE: 'Scope Of Work',
      INFO: 'Tender Info',
      PAYMENT: 'Payment',
      OPTIONS_PAYMENY: 'Select any payment options to proceed with payment',
      REQUEST: 'Payment Confirmed for a Tender Request #123456',
      CONGRATS: 'Congratulations your document is ready to download from the following link',
      DOWNLOAD: 'Download Receipt',
      INVOICE: 'Invoice Date',
      DATE: 'Date',
      TIME: 'Time',
      DOWNLOAD_TENDER: 'Download Tender Document',
      RECIPE_SUMMARY: 'Recipe Summary',
      CUSTOMER: 'Customer Name',
      MOBILE: 'Mobile Number',
      PAYMENY_DATE: 'Payment Date',
      RECIPE_NO: 'Recipe No.',
      RECIPT_NO: 'Receipt number',
      TRANSACTION: 'Transaction ID',
      TOTAL: 'Total Amount Paid'

    },
    PLURAL: {
      JOB: {
        ZERO: '{{count}} jobs',
        SINGULAR: '{{count}} job',
        DUAL: '{{count}} jobs',
        BETWEEN_THREE_NINE: '{{count}} jobs',
        TEN: '{{count}} jobs',
        MORE_THAN_TEN: '{{count}} jobs'
      },
      DAYS_LEFT: {
        ZERO: '{{count}} Days Left',
        SINGULAR: '{{count}} Day Left',
        DUAL: '{{count}} Days Left',
        BETWEEN_THREE_NINE: '{{count}} Days Left',
        TEN: '{{count}} Days Left',
        MORE_THAN_TEN: '{{count}} Days Left'
      }
    },
    ERRORS: {
      You_must_validate_your_email_first: "You must validate your email first.",
      You_must_write_a_valid_email_address: "You must write a valid email address",
      This_day_date_is_a_holiday: 'This day {{date}} is a holiday',
      This_day_date_is_an_offday: 'This day {{date}} is an offday',
      Appointment_already_cancelled: "Appointment already cancelled.",
      set_limit_between_QR_val1_to_QR_val2: 'Set limit between QR {{val1}} to QR {{val2}}',
      something_went_wrong: "something went wrong",
      "This_vehicle_has_no_fees": "This vehicle has no fees",
      at_least_3_characters_are_required: "at least 20 characters are required",
      at_least_33_characters_are_required: "at least 3 characters are required",
      at_least_11_characters_are_required: "at least 11 characters are required",
      THIS_FIELD_IS_REQUIRED: "Field can't be empty",
      YOUR_BROWSER_DOES_NOT_SUPPORT_HTML5_VIDEO: 'Your browser does not support HTML5 video.',
      Email: "The email address you entered is invalid",
      CR: 'The passport you entered is invalid',
      VALUE_TOO_LOW: 'Value Too Low',
      VALUE_EXCEEDS_LIMIT: 'Value Exceeds Limit',
      EMAILS_DO_NOT_MATCH: 'Email Do Not Match',
      PATTERN: 'The passport must follow this format: xx-xxxx-xx.',
      DATE: 'Kindly ensure that both "Date From" and "Date To" are filled in to apply the filter correctly.',
      ERROR: 'Error',
      PAGE_NOT_FOUND: 'page not found',
      CANT_FIND: 'Sorry, we can’t find the page you’re looking for.',
      GO_HOME: 'Go back to Home page',
      LOGIN_MOBILE_NUMBER:'Please enter a valid mobile number',
      Fahes_incpection:'The information you have provided is not matching with any vehicle information',
    },
    SIGN_IN: {
      verifing: 'Verifying',
      Please_enter_OTP: 'Please enter OTP',
      We_have_sent_verification_code_to_your_Email: 'We have sent verification code to your Email, please check your Email.',
      We_have_sent_verification_code_to_your_mobile_number: 'We have sent verification code to your mobile number',
      Verification_Code_sent_to: 'Verification Code sent to',
      Enter_the_Code: 'Enter the Code',
      Resend_PIN: 'Resend PIN',
      sec: 'sec',
      Verify_Code: 'Verify Code',
      Confirm: 'Confirm',
      LOG_IN: 'Login',
      Login_by_mobile_number: "Login by mobile number",
      Email_Address: "Email Address",
      Enter_Email_Address: "Enter Email Address",
      Enter_Verification_Code: "Enter Verification Code",
      Verification_Code: '929396',
      Send_OTP: 'Send OTP',
      or: 'or',
      Login_by_Email: 'Login by Email',
      Protected_by_reCAPTCHA_and_subject_to_the: 'Protected by reCAPTCHA and subject to the',
      Woqod_Privacy_Policy: 'Fahes Privacy Policy',
      and: 'and',
      Terms_of_Service: 'Terms of Service',
      FULL_ADDRESS: 'Full Address',
      SIGN_IN_WOQOD: 'Sign in Fahes',
      ENTER_MOBILE_NUMBER: 'Enter Mobile Number',
      RESEND_IN: 'Resend in',
      RESEND: 'Resend',
      ENTER_VERIFICATION_CODE: 'Enter Verification Code',
      LOGIN: 'Login',
      OR: 'or',
      CONTINUE_AS_A_GUEST: 'Continue as a guest',
      ENTER_YOUR_PROFILE_DETAILS: 'Enter your profile details',
      FULL_NAME: 'Full Name',
      EMAIL: 'Email',
      ADDRESS: 'Address',
      DATE_OF_BIRTH: 'Date of Birth',
      IAM_MAN: "I'm Man",
      IAM_WOMAN: "I'm Woman",
      CONTINUE: 'Continue',
      PROTECTED_BY_RECAPTCHA_AND_SUBJECT_TO_BE: 'Protected by reCAPTCHA and subject to the',
      WOQOD_PRIVACY_POLICY: 'Woqod Privacy Policy',
      AND: 'and',
      TERMS_OF_SERVICE: 'Terms of Service',
      FIRST_NAME: 'First Name',
      LAST_NAME: 'Last Name',
      VERIFY: 'Verify',
      QID: 'QID',
      QID_PASSPORT: 'QID/Passport',
      POBOX: 'Po Box',
      COUNTRY: 'Country',
      CITY: 'City',
      STREET: 'Street address',
      GENDER: 'Gender',
      MALE: 'Male',
      FEMALE: 'Female'

    },
    SEARCH: {
      ALL_FAQS: "All FAQ's",
      WRITE_HERE: 'Write here..',
      KEYWORD_SUGGESTIONS: 'keywords Suggestions',
      HISTORY: 'Recent searches',
      SEARCH: 'Search',
      SEARCH_RESULT: 'Search results for',
      READ_MORE: 'READ MORE',
      FILTER_BY_CATEGORY: 'Filter by category',
      SELECT_CATEGORY: 'Select cateogry',
      FILTER_BY_TAG: 'Filter by tag'
    },
    SUPPLIER: {
      VIEW_FORM: 'View Form',
      SUBSCRIBE_FOR_THE_TENDER_ALERTS: 'Subscribe for the Tender alerts',
      PLEASE_TICK_THE_BOX_BEFORE_SUBMITTING: 'Please tick the box before submitting',
      COMPANY_INFORMATION: 'Company information',
      VENDOR_NAME: 'Vendor Name',
      VENDOR_NUMBER: 'Vendor Number',
      COMPANY_REGISTRATION_NUMBER_INTERNATIONAL_CORPORATE_ID: 'Company Registration Number/ International Corporate ID',
      COMPANY_REGISTRATION_EXPIRY: 'Company Registration Expiry',
      COMPANY_CATEGORY: 'Company Category',
      COMPANY_SUB_CATEGORY: 'Company Subcategory',
      DAREEBA_TIN: 'Dareeba TIN',
      ICV_CERTIFICATE_NUMBER: 'ICV certificate Number',
      ICV_CERTIFICATE_EXPIRY: 'ICV Certificate Expiry',
      ICV_SCORE: 'ICVScore',
      PRIMARY_CONTACT_NUMBER: 'Primary Contact Number',
      SECONDARY_CONTACT_NUMBER: 'Secondary Contact Number',
      CONFIRM_EMAIL: 'Confirm Email',
      AUTO_CARE_SUPPLIER: 'Auto Care Supplier',
      AUTO_CARE_FOR_CORPORATES: 'Auto Care For Corporates',
      ALL: 'All Category'
    },
    RETAIL: {
      FUEL_RETAIL_PRICES: 'Fuel Retail Prices',
      BZS_LITER: 'Bzs/Liter',
      QR_LITER: 'QR/Liter',
      BECOME_A_SUPPLIER_FOR_SIDRA: 'Become a Supplier for Sidra',
      BECOME_A_SUPPLIER_AUTO_CARE: 'Become a suppler for Auto Care',
      CONTACT_PERSON: 'Contact Person',
      TELEPHONE_NUMBER: 'Telephone Number',
      PHONE_NUMBER: 'Phone Number',
      MAILING_ADDRESS: 'Mailing Address',
      EMAIL: 'Email',
      FAX_NUMBER: 'Fax Number',
      OFFICE_ADDRESS: 'Office Address',
      FOR_ADDITIONAL_INFORMATIONS: 'For Additional Informations',
      VALID_COMPANY_REGISTRATION: 'Valid Company Registration',
      YES: 'Yes',
      NO: 'No',
      SAVE_AND_CONTINUE_LATER: 'Save & Continue Later',
      NEXT: 'Next',
      BACK: 'Back',
      YOUR_REMARKS: 'Your Remarks',
      PRODUCT_CATEGORY: 'Product Category',
      PAYMENT_TERMS_NUMBER_OF_DAYS: 'Payment Terms (Number of days)',
      BOOK_NOW: 'Book Now',
      QID: 'QID',
      VEHICLE_PLATE_TYPE: 'Vehicle plate type',
      VEHICLE_PLATE_NUMBER: 'Vehicle plate number',
      VEHICLE_TYPE: 'Vehicle type',
      TYPE: 'Type',
      SAVED_VEHICLES: 'Saved Vehicles',
      MANUFACTURER_NAME: 'Manufacturer Name',
      PETROL_STATION: 'Petrol station',
      MODEL: 'Model',
      BEST_TIME_TO_CALL: 'Best Time to Call',
      CATEGORY_OF_BUSINESS: 'Category Of Business',
      EXPECTED_DATE_TO_START_BUSINESS_OPERATIONS: 'Expected date to start business operations',
      VAIDATE: 'VALIDATE',
      PAYMENT_TERMS: 'Payment Terms (Number of days)',
      DELIVERY_FREQUENCEY: 'Delivery Frequency',
      ORDERING_LEAD_TIME: 'Ordering Lead Time',
      SCOPE_OF_DELIVERY: 'Scope of Delivery',
      APPROVE_FOR_LISTING: 'Approve for Listing',
      TIME: 'Time',
      PAYMENT: 'Select any payment options to proceed with payment',
      SUBMIT: 'Submit'
    },
    FAQ: {
      FAQS: "FAQs",
      VIEW_ALL_FAQS: "View All FAQ's",
      ALL_CATEGORY: 'All Category'
    },
    TINDER: {
      "Current_Status": "Current Status",
      "bid_closing_date": "Bid Closing Date",
      "tender_publish_date": "Tender Publish Date",
      VENDOR_NAME: 'Vendor Name',
      ADDRESS: 'Address',
      CONTACT_NAME: 'Contact Name',
      CONTACT: 'Contact#',
      COLLECT_TINDER_DOCUMENT: 'Collect Tinder Document',
      AWARD_TENDERS: 'Award Tenders',
      CLOSED_TENDERS: 'Closed Tenders',
      OPEN_TENDERS: 'Open Tenders',
      SEARCH_BY_AREA_NAME: 'Search by Title',
      SEARCH_BY_AREA_NUMBER: 'Search by Number',
      SR_NO: 'SR NO',
      TENDER_NO: 'Tender Number',
      DESCRIPTION: 'Description',
      LAST_COLLECTION_DATE: 'Last Collection Date',
      BOND: 'Tender Bond',
      BOND_QA: 'Tender Bond(QR)',
      FEE_QA: 'Tender Fee(QR)',
      FEE: 'Fee',
      CATEGORY: 'Category',
      REQUEST: 'Request',
      VIEW_ALL_TINDERS: 'View All Tenders',
      ACTIVE_TINDER: 'Open Tenders',
      TENDER_TITLE: 'Tender Title',
      SERIEL_NUMBER: 'Sr. No.',
      INFORMATION: 'Information',
      SUCCESSFUL: 'Successful bidder',
      DETAIL: 'View Details',
      CLOSING_DATE: 'Close Date',
      View_DETAIL: 'View ',
      BID_CLOSING_DATE: 'Bid Closing Date',
      START_DATE: 'Planned tender Issue Date'
    },
    TIMELINE: {
      HOW_TO_USE: 'Know How To Use'
    },
    TABS: {
      INDIVIDUAL: 'Individual',
      CORPORATE: 'Corporate',
      PRODUCTS: 'Products',
      SERVICES: 'Services',
    },
    PRICE_TABLE: {
      PRICE_TABLE: 'Price Table',
      SEE_PRICES: 'See Prices',
      PER_TAG: 'PER TAG'
    },
    BUSINESS: {
      INITIATE_CONTRACT: 'Initiate Contract'
    },
    PRICES: {
      PRICES: 'Prices',
      VIEW_ALL_PRICES: 'View All Prices',
      BOOK_AN_APPOINTMENT: 'Book an Appointment',
      PRICE_LIST: 'Price List',
      PRICE_IN: 'Price in'
    },
    STEPS: {
      GET_INSPECTED: "Get Inspected",
      PAY_NOW: "Pay now",
      CONFIRMATION: "Confirmation",
      SHOP_INFORMATION: 'Shop Information',
      PERSONAL_INFORMATION: 'Personal Information',
      BUSINESS_INFORMATION: 'Business Information',
      ATTACHMENTS: 'Attachments',
      SUBMISSION: 'Submission',
      GENERAL_DETAILS: 'General Details',
      VEHICLE_DETAILS: 'Vehicle Details',
      BOOK_APPOINTMENT: 'Book Appointment',
      TERMS_AND_CONDITIONS: 'Terms & Conditions',
      PAYMENT: 'Payment',
      SAVED_CARDS: 'Saved Cards',
      OPTIONS: 'Other payment options',
      EXPIRY: 'EXPIRY DATE',
      DELETE: 'Delete this card',
      SECURELY: 'Pay securely using debit cards issued in Qatar',
      A_SECURE: 'A secure and easy way to pay with credit cards',
      PROCEED: 'Proceed',
      DEBIT: 'Debit Card',
      CREDIT: 'Credit Card',
      APPLE_PAY: 'Apple Pay'
    },
    E_TAG: {
      WALLET_LIMIT: 'Wallet Limit',
      REQUEST_A_NEW_E_TAG: 'Request A New E-Tag',
      IF_YOU_HAVE_ALREADY_INSTALLED_A_TAG_AND_WANT_TO_REPLACE_IT_KINDLY: 'If you have already installed a tag and want to replace it,kindly',
      CLICK_HERE: 'click here',
      NAME: 'Name',
      QID: 'QID',
      INVOICE: 'Invoice',
      TRACKING: 'Tracking',
      EMAIL: 'Email',
      MOBILE_NUMBER: 'Mobile Number',
      NATIONAL_ADDRESS: 'National Address',
      ZONE_NUMBER: 'Zone Number',
      STREET_NUMBER: 'Street Number',
      BUILDING: 'Building',
      UNIT: 'Unit',
      PO_BOX: 'PO Box',
      FAX_NUMBER: 'Fax Number',
      VEHICLE_DETAILS: 'Vehicle Details',
      VEHICLE_STATUS: 'Vehicle Status',
      MODEL: 'Model',
      MODEL_YEAR: 'Model Year',
      MANUFACTURE_TO_BE_BRAND: 'Manufacture to be (Brand)',
      EXPIRY_DATE: 'Expiry Date',
      SEQUENCE_NUMBER: 'Sequence Number',
      INSURANCE_COMPANY_NAME: 'Insurance Company Name',
      START_DATE: 'Start Date',
      REGISTRATION: 'Registration',
      STATUS: 'Status',
      VEHICLE_ID_NUMBER: 'Vehicle ID Number',
      INSURANCE_EXPIRATION_DATE: 'Insurance Expiration Date',
      PHONE_NUMBER: 'Phone Number',
      SAVE_VEHICLE: 'Save Vehicle',
      NUMBER_OF_VEHICLES: 'Number of Vehicles',
      NUMBER_OF_TAGS: 'Number of Tags',
      TOTAL_PRICE: 'Total Price',
      ADD_BENEFICIARY: 'Add Beneficiary',
      CONFIRM: 'Confirm',
      SELECT_CAR: 'Select Car',
      ADD_A_NEW_CAR: 'Add a New Car',
      CAR: 'Car',
      SEARCH_BY_NUMBER_PLATE: 'Search by plate number',
      RE_INSPECTION: 'Re - Inspection',
      ADD: 'Add',
      DETAILS: 'Details',
      QID_CR: 'QID/CR',
      UPLOAD_FILE: 'Upload file here',
      U_FILE: 'Upload file',
      ESTIMARA: 'ESTIMARA',
      INSTALLATION_COST: 'Installation cost',
      TAG_ID: 'Tag ID',
      TAG_FEE: 'Tag Fee',
      COST_OF_INSTALLATION: 'Cost of installation',
      TOTAL: 'Total',
      BOOK_DETAILS: 'Book Details',
      PAYMENT_METHOD: 'PAYMENT METHOD',
      CREDIT_CARD: 'Credit Card',
      KFAST: 'KFAST',
      AMEX: 'AMEX',
      OTHER_METHODS: 'OTHER METHODS',
      CREDIT_LIMIT: 'Credit Limit',
      NET_BANKING: 'Net Banking',
      E_Wallet: 'E - Wallet',
      APPLE_WALLET: 'Apple wallet',
      NEW_CARD: 'New Card',
      NAME_ON_THE_CARD: 'Name on the Card',
      CARD_NUMBER: 'Card Number',
      VALID_TILL: 'Valid Till',
      CVV: 'CVV',
      COST_OF_TAG: 'Cost of Tag + Installation Charge',
      PLATE_NUMBER: 'Plate Number',
      PLATE_TYPE: 'Plate Type',
      TRANSACTION: 'Transaction Limit (QRA or liter)*',
      FUEL_TYPE: 'Fuel Type *',
      FUEL_LIMIT: 'Fuel Limit Duration *',
      MAJOR: 'Major Color',
      VEHICLE_INFORMATION: 'Vehicle Information',
      VEHICLE_INSURANCE: 'Vehicle Insurance Details',
      PHONE: 'Phone Number *',
      FAMILY: 'Family relation between customer account and vehicle owner',
      NUMBER_PLATE: 'Plate number',
      MANUFACTOR: 'Manufactor',
      SELECT_A_BENEFICIARY: 'Add Beneficiary',
      ADD_NEW_BENEFICIARY: 'Add a New Beneficiary',
      DAYS: 'Days Remaining',
      BOOKED_ON: 'Booked on',
      BOOKED_DETAILS: 'Booking Details',
      Name_AR: 'Name (AR)',
      NUMBER_OF_TAG: 'Number Of Tags',
      BY_NAME: 'Search by Service Name',
      SERVICE_NAME: 'Service Name',
      STATION: 'Station',
      Max: 'Maximum Size',
      MB: 'MB',
      SHOULD_BE: 'Please ensure the file you upload is in',
      FORMAT: 'format and does not exceed',
      IN_SIZE: 'in size.',
      "You_can_upload_multiple_files": "You can upload multiple files."
    },
    SHOP: {
      BACK: 'Back',
      SUBMIT: 'Submit',
      VEHICLE_TYPE: 'Vehicle type',
      EXISTING_TENANT: 'Existing Tenant',
      I_ACCEPT_AND_AGREE_TO_THE_FOLLOWING_TERMS_AND_CONDITIONS: 'I accept and agree to the following terms & Conditions:',
      RENT_A_SHOP: 'Rent a Shop',
      BACK_TO_AVAILABLE_SHOPS_PAGE: 'BACK TO AVAILABLE SHOPS PAGE',
      DEADLINE: 'Deadline',
      LOCATION: 'Location',
      FIRST_NAME: 'First Name',
      STATION_NAME: 'Station Name',
      NUMBER_APPLICANTS: 'Number of applicants as of now',
      SHOP_PRE: 'Shop rent per month (QR) per square meter',
      SHOP_SIZE: 'Shop Size sqm',
      NUMBER_OF_SHOPS: 'Number of shops required *',
      OPTION: 'Opitonal',
      LIST_LOCATIONS_IF_ANY: 'List Locations (if any)',
      REQUIRED_INFORMATION: 'Required Information',
      NEXT: 'Next',
      MIDDLE_NAME: 'Middle Name',
      LAST_NAME: 'Last Name',
      MOBILE_NUMBER: 'Mobile Number',
      OFFICE_TELEPHONE_NUMBER: 'Office Telephone Number',
      EMAIL: 'Email',
      COMPANY_NAME: 'Company Name',
      DATE: 'Date',
      WHY_WOQOD_SHOULD_CONSIDER_YOU_FOR_LEASING_A_SHOP: 'Why WOQOD should consider you for leasing a shop?',
      WHAT_ADDITIONAL_VALUE_PRODUCTS_SERVICES_YOUR_BUSINESS_WILL_OFFER_TO_WOQOD_CUSTOMERS: 'What additional value (products / services)<br/>your business will offer to WOQOD customers?',
      WILL_YOU_HAVE_A_PARTNER: 'Will you have a Partner?',
      COMPANY_TURNOVER_IN_QATAR: 'Company Turnover in Qatar',
      NUMBER_OF_EMPLOYEES: 'Number of Employees',
      VALIDATE: 'Validate',
      CR_NUMBER: 'CR Number',
      CR_NUMBER_Attach: 'CR Number',
      NUMBER_OF_BRANCHES_IN_GSS: 'Number of Branches in GCC',
      NUMBER_OF_BRANCHES_IN_QATAR: 'Number of Branches in Qatar',
      TERMS_AND_CONDITIONS: 'Terms and conditions',
      TERMS_AND_CONDITIONS_FOR_BALLOTING: 'Terms and conditions for Balloting',
      TERMS_AND_CONDITIONS_FOR_PROPERTY_RENTALS: 'Terms and conditions for Property Rentals',
      PAYMENT_SUCCESSFUL: 'Payment Successful',
      FUEL_TYPE_CHANGED: 'Fuel Type Changed',
      LIMITED_HOURS: 'Limited Hours',
      FRANCHISE_COMPANY: 'Franchise Company',
      COMMERCIAL_REGISTRATION_CR_COPY: 'Commercial Registration (CR copy)',
      COPY_OF_COMPUTER_CARD_OR_TRADING_LICENSE: 'Copy of Computer Card or Trading License',
      BANK_ACCOUNT_DETAILS_IN_THE_COMPANY_LETTERHEAD: 'Bank Account Details in the Company Letterhead',
      LETTER_FROM_BANK_CONFIRMING_THE_ACCOUNT: 'Letter from bank confirming the account',
      COPY_OF_OWNERS_ID: 'Copy of Owner’s ID',
      COMPANY_PROFILE: 'Company Profile',
      BRANDING_PROFILE: 'Branding profile',
      I_AGREE: 'I agree',
      START_DATE: 'Start date',
      END_DATE: 'End date',
      SUPPLIER_NAME: 'Supplier Name',
      CONTACT_PERSON: 'Contact Person',
      TRADE: 'Trade License',
      TAX_CARD: 'Tax Card',
      AUTO_CARE: 'Auto Care Services',
      PRODUCT: 'Product description',
      INSURANCE_COMPANY: 'Insurance Company List',
      INSURANCE: 'Insurance Company',
      CR_START_DATE: 'CR Start date',
      CR_END_DATE: 'CR End date',
    },
    UPLOADER: {
      ATTACH: 'Attach'
    },
    DAYS: {
      MON: "Mon",
      TUE: "Tue",
      WED: "Wed",
      THU: "Thu",
      FRI: "Fri",
      SAT: "Sat",
      SUN: "Sun"
    },
    INSPECTION_FILTER: {
      SELECT_YOUR_PETROL_STATION_TYPE_NEW: 'Select Your Petrol Station Service Type',            
      FULL_DAY_FULL_WEEK: '24 hours / 7 days a week',
      CHOOSE_STATION: 'CHOOSE STATION',
      CHOOSE_INSPECTION_CENTER: 'CHOOSE INSPECTION CENTER',
      CHOOSE_ANY: 'CHOOSE ANY',
      CHOOSE_STATUS: 'CHOOSE STATUS',
      SELECT_YOUR_PETROL_STATION_TYPE: 'Select Your Station Type',
      SELECT_YOUR_PETROL_STATION_STATUS: 'Select Your Petrol Station Status',
      SELECT_BY_SERVICE_AVAILABLE: 'Select By Service Available',
      SEARCH_LOCATIONS: 'Search Locations',
      EG: 'Eg',
      WORKING_HOURS: 'Working Hours',
      SORT_BY: 'Sort by',
      SORT_BY_NEAREST_STATIONS: 'Sort by nearest stations',
      OPEN_24_HOURS: 'Open 24 hours',
      DIRECTION: 'Direction',
    },
    TIME: {
      CHOOSE_TIME: 'Choose time'
    },
    WOQODE_TAG: {
      STEP: 'Step',
      HOW_TO_TOP_UP: 'How to top up?',
      SUCCESS:'Your booking for your E-tag installation of the Car no.',
      SUCCESS_APC:'Your booking of the Car no.',
      COMPLETE_SUCCESSFULLY: 'has been confirm.',
    },
    SEARCH_BY_TITLE: {
      DEADLINE: 'Deadline',
      RENT_SHOP: 'Rent Shop',
      SEARCH_BY_TITLE: 'Search by Title',
      SUBMIT_INTEREST_IN_LEASING_A_SHOP: 'Submit Interest In Leasing A Shop'
    },
    SIDRA: {
      VISIT_SIDRA_WEBSITE: 'Visit Sidra Website',
      SHOP_NOW: 'Shop Now'
    },
    RENT_SHOP_TERMS_CONDITION: {
      CHECKBOX1: 'I (applicant) will submit refundable Managerial cheque / (Bank guarantee) amounting to Qr.10,000 /- for each shop, issued in favor of WOQOD at (WOQOD Tower, West Bay, 16th Floor, Retail Department) within 3 working days from the day of application submission, for participation in shop balloting process. WOQOD will have absolute right to forfeit security amount, in case the applicant refuses to take allotted shops.',
      CHECKBOX2: 'The applicant will have no right to sub-lease the kenar shop.',
      CHECKBOX3: 'The applicant will not be allowed to change ownership or nature of business.',
      HOMEPAGE: 'To proceed recharge you agree the Terms and Conditions',
    },
    PRODUCT_AND_SERVICE: {
      WOQODE: 'WOQODe',
      FUEL: 'Fuel & Retail',
      WAQOD: 'Auto Care',
      READ_MORE: 'READ MORE',
      KINAR: 'Kenar',
      SIDRA: 'Sidra',
      SHAFAF: 'Shafaf',
      BULK: 'Bulk Fuel',
      FAHES: 'FAHES Vehicle Inspections',
      DISTRIBUTION: 'Fuel Distribution',
      GAS: 'Gas Distribution',
      AVIATION: 'Aviation Supply',
      LUBRICANTS: 'WOQOD Lubricants',
      VIEW_OTHER_PRODUCTS: 'View Other Products',
      ENTER_YOUR_QUERIES: 'Enter Your Queries',
      FOR_MORE_INFORMATION: 'For more information',
      DIGITAL:' WOQOD Digital',
    },
    SHAFAF: {
      RATES: 'Cylinder Sizes',
      LPG_ACCESSORIES: 'LPG accessories',
      VISIT_SHAFAF: 'Visit shafaf Website',
      WHERE_TOBUY_SHAFAF: 'Where To Buy Shafaf',
      VIEW: 'View List',
      STORES:'(Available in all Sidra stores)',
    },
    WOQOD_APP: {
      APP: 'E-services available on Mobile application to fulfill all marketplace service needs!',
      DOWNLOAD: 'Download WOQOD App Now!!'
    },
    FUELMODAL: {
      TITLE: 'Fuel Price for the year',
      MONTH: 'Month',
      GAS_SUPER: 'Gasoline Super (95)',
      GAS_PRE: 'Gasoline Premium (91)',
      DIESEL: 'Diesel',
    },
    MODALWOQOODE: {
      TITLE: 'Services',
      INDIVIDUAL: 'Individual Customers',
      PRICE: 'Price in QAR',
      LEVEL: 'Level',
      CLICKC: 'Click here For WOQODE Corporates',
      CLICKI: 'Click here For WOQODE Individual',
      CORPORATE: 'Corporate Customers',
      TAGS: 'Tags',
      FROM: 'From',
      TO: 'To',
    },
    FILTER_DDL: {
      CONTACT_NUMBER: 'Sort By Contact Number Asc',
      CONTACT_NUMBER_DESC: 'Sort By Contact Number Desc',
      TITLE: 'Sort By Title',
      STATION: 'Sort By Station Asc',
      STATION_DESC: 'Sort By Station Desc',
      ADDRESS: 'Sort By Address Asc',
      ADDRESS_DESC: 'Sort By Address Desc',
      CONTACT_NAME: 'Sort By Contact Name Asc',
      CONTACT_NAME_DESC: 'Sort By Contact Name DESC',
      TITLE_DESC: 'Sort By Title Desc',
      TITLE_ASC: 'Sort By Title Asc',
    },
    TENDER_MODAL: {
      CR_CERTIFICATE: 'CR CERTIFICATE',
      ADDRESS: 'National Address',
    },
    WOQODE_APPINTMENT: {
      E_TAG: 'Request A New E-Tag',
      PROFILE: 'Profile',
      VEHICLE: 'Vehicle',
      TAG: 'E-Tag',
      APPOINTMENT: 'Appointment',
      CONFIRMATION : 'Confirmation',
      BOOK:'Book A Service',
      BOOK_another:'Book Another Service',
      TERMS: 'Terms and conditions for Woqod E-Tag',
      TERMS_dynamic: 'Terms and conditions for {{service}}',
      CONFIRM: 'Confirm',
      BACK:'Back',
      confirmation_message: 'Booking for Plate no. {{plateNumber}} has been confirmed. You will receive the confirmation message on your registered email.',
      MAIN:'Go to home',
      DASHBORAD:'Go to dashboard',
      SELECT_A_SERVICE: 'Select a Service',
      SELECT_ANY: 'Select any one from the below to proceed',
      "Are_you_sure_you_want_to_cancel_the_payment": "Are you sure you want to cancel the payment?",
      "Are_you_sure_you_want_to_cancel_the_appointment": "Are you sure you want to cancel the appointment?",
    },
    PLACEHOLDER: {
      DDMMYYYY: 'DD-MM-YYYY',
      from_date: 'From Date',
      to_date: 'To Date',
      ENTER_COMPANY_NAME: 'Enter company name',
      DECLARATION: 'Declaration',
      PRODUCT_DESCRIPTION: 'Product Description',
      QID: 'ex: 29712345678',
      EMAIL: 'ex: John@gmail.com',
      SUPPLIER_NAME: 'ex: AIN Snan Petrol Staion',
      CONTACT_PERSON: 'ex: John Samuel',
      CR_NUMBER: 'ex: 22445',
      S_DATE: 'ex: 20 / 2 / 2020',
      E_DATE: 'ex: 20 / 2 / 2020',
      F_NAME: 'ex: John',
      M_NAME: 'ex: Samuel',
      L_NAME: 'ex: Johnne',
      MOBILE: 'ex: +(947) 45678967',
      COMPANY_NAME: 'ex : WOQOD company',
      COMPANY_NAME_AR: ' شركة وقود',
      NUMBER: 'ex : 20',
      NUMBER_GCC: 'ex : 68',
      EMPLOYE_NUMBERR: 'ex : 368',
      LIST_LOCATIONS: 'Enter List Locations (if any)',
      CUSTOMER: 'Enter details about the additional value, products, or services your business plans to offer to WOQOD customers.',
      LEASING: 'Please provide your reasons why WOQOD should consider you for leasing a shop.',
      TURNOVER: "Enter your company's turnover in Qatar (QAR)*",
      NATIONALTIY: 'Select your nationality',
      EDUCATION: "Select your Educational Qualification",
      FIELD: 'Select your Field Of Study',
      CURRENT: 'Select your Current Employment Status',
      YEARS: 'Select your Years of Experience',
      INDUSTRY: 'ex: Manufacturing',
      EMPOYLER: 'ex: ABC Company',
      FULL_NAME: 'ex: John Samuel',
      AHMED: 'Ahmed',
      FEEDBACK_TITLE: 'ex: Your Feedback Title',
      FEEDBACK_TITLE_AR: 'ex: Your Feedback Title In Arabic',
      COMPANY: 'WOQOD company',
      COMMENTS: 'Enter your comments here...',
      ZONE: 'Enter Zone Number (ex: 123)',
      BUILDING: 'Enter Building Name or Number',
      UNIT: 'Enter unit Name or Number',
      NAME_EN: 'John Samuel',
      NAME_AR: 'جون صموئيل',
      ENTER_LOCATION: 'Enter a Location',
      SHOW_ALL: 'Show All',
      ACTIVE_ONLY: 'Active only',
      NEARSET: 'Nearest',
      NEWLY_ADDED: 'Newly added',
      BY_STATION: 'Search by Station Name',
      DEADLINE: 'DeadLine Asc',
      LASTEST_ADDED: 'Latest Added',
      SIZE_ASC: 'Size Asc',
      SIZE_DESC: 'Size Desc',
      DATE_FROM: 'From Date',
      DATE_TO: 'To Date',
      CORORATE_ID: 'Enter Company Registration Number/International Corporate ID',
      CERTEFICATE_NUMBER: 'ex: ABC-9876543',
      ICV_SCORE: 'ex: 48 points',
      DATE: 'DD-MM-YYYY',
      COUNTRY: 'Country',
      GENDER: 'Mr / Ms',
      TITLE: 'Title',
      VALID_NUMBER: 'Enter a valid number',
      VALID_EMAIL: 'Enter a valid email',
      ENTER_YOUR_NAME: 'Enter your name',
      CURRENT_EMPLOYER: 'ex : Software Engineer',
      DEVELOPER: 'ex : Developer',
      ENTER_YOUR_EMAIL: 'Enter your email',
      ENTER_YOUR_MOBILE_NUMBER: 'Enter your mobile number',
      ENTER_YOUR_DESCRIPTION: 'Enter your description',
      ENTER_PLATE_NUMBER: 'Enter Plate Number',
    },
    PAYMENT: {
      "credit card": "credit card",      
      "Debit Card": "Debit Card",
      ID: 'Transaction ID',
      DATE: 'Transaction Date',
      METHODS: 'Payment Methods',
      TOTAL: 'Total Topup Amount',
      CONGRATS: 'Congratulations',
      INTO_WALLET: 'added into your wallet',
      YOU_HAVE: 'You’ve',
      AVAILABLE: 'available in the Wallet',
      PAYMENT_FAILED: "The payment was not completed. Try again or use another payment method.",
      CARD_SAVED_SUCCESSFULLY: 'Card Saved Successfully',
      CANCEL: 'The transaction has been cancelled',
      TOPUP_COMPLETED: 'Top-up Completed',
      BALANCE: 'your current balance is',
      PRINT: 'Download Receipt',
      DETAILS: 'Transaction Details',
    },
    INVESTOR: {
      RELATIONS: 'investor relations',
      EXECUTIVE_MANAGEMENT: 'Executive Management',
    },
    CONTACT: {
      Timing: 'Office Timing',
      WE_ARE_OPEN: 'We are open',
      TODAY: 'From 7am to 2pm (Sunday - Thursday)',
      EMAIL: 'Send us an email',
      FAX: 'Give us a fax',
      CALL: 'Give us a call'
    }
  }
};
